import localization from './localization';
import user from './user';
import statics from './statics';
import profile from './profile';
import documents from './documents';
import client from './client';
import account from './account';
import accountPortfolio from './portfolio';
import location from './location';
import wallets from './wallets';
import mandates from './mandates';
import preprocessingFundProfiles from './preprocessingFundProfiles';
import peerProfiles from './peerProfiles';
import peerCategories from './peerCategories';
import aums from './aums';
import fees from './fees';
import simulation from './simulation';
import modelPortfolios from './modelPortfolios';
import financialAdvisor from './financialAdvisor';
import addresses from './addresses';
import notifications from './notifications';
import instruments from './instruments';
import crm from './crm';
import investmentObjectives from './investmentObjectives';
import portfolioProposals from './portfolioProposals';
import portfolios from './portfolios';
import watchlists from './watchlists';

export const sagas = [
  ...localization,
  ...user,
  ...statics,
  ...profile,
  ...addresses,
  ...documents,
  ...client,
  ...account,
  ...location,
  ...wallets,
  ...mandates,
  ...preprocessingFundProfiles,
  ...peerProfiles,
  ...peerCategories,
  ...instruments,
  ...aums,
  ...fees,
  ...simulation,
  ...portfolios,
  ...modelPortfolios,
  ...accountPortfolio,
  ...financialAdvisor,
  ...notifications,
  ...crm,
  ...investmentObjectives,
  ...portfolioProposals,
  ...watchlists,
];

export const sagasWithoutUser = [
  ...localization,
  ...statics,
  ...profile,
  ...addresses,
  ...documents,
  ...client,
  ...account,
  ...location,
  ...wallets,
  ...mandates,
  ...preprocessingFundProfiles,
  ...peerProfiles,
  ...peerCategories,
  ...instruments,
  ...aums,
  ...fees,
  ...simulation,
  ...portfolios,
  ...modelPortfolios,
  ...accountPortfolio,
  ...financialAdvisor,
  ...notifications,
  ...investmentObjectives,
  ...portfolioProposals,
  ...watchlists,
];
